import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NavService } from '../../../../services/nav.service';
import { Language, LayoutService } from '../../../../services/layout.service';

@Component({
	selector: 'app-languages',
	templateUrl: './languages.component.html',
	styleUrls: ['./languages.component.scss']
})
export class LanguagesComponent implements OnInit {
	public language: boolean = false;

	public languages: any[] = [
		{
			language: 'English',
			code: 'en',
			type: 'US',
			icon: 'us'
		},
		{
			language: 'Français',
			code: 'fr',
			icon: 'fr'
		},
		{
			language: 'Arabe',
			code: 'ar',
			type: 'AR',
			icon: 'ma'
		}
	];

	public selectedLanguage: Language;

	constructor(
		private el: ElementRef,
		public navServices: NavService,
		private translate: TranslateService,
		private layoutService: LayoutService
	) {}
	//
	ngOnInit() {
		this.initLanguageData();
	}

	initLanguageData() {
		this.selectedLanguage = this.layoutService.getCurrentLanguage();
	}

	changeLanguage(lang?: any) {
		this.selectedLanguage = lang;
		this.layoutService.changeLanguage(this.selectedLanguage);
		window.location.reload();
	}
	@HostListener('document:click', ['$event'])
	onClickOutside(event: MouseEvent) {
		if (!this.el.nativeElement.contains(event.target)) {
			this.navServices.language = false;
		}
	}
}
